// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientListScopeByResponsibleUserField_container__JZjNh"};